var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "carousel",
    _vm._g(
      _vm._b(
        {
          ref: "my_carousel",
          scopedSlots: _vm._u(
            [
              _vm._l(_vm.$scopedSlots, function(slot, name) {
                return {
                  key: name,
                  fn: function(props) {
                    return [_vm._t(name, null, null, props)]
                  }
                }
              }),
              {
                key: "pagination",
                fn: function() {
                  return [
                    _c("custom-pagination", {
                      attrs: { "show-title": _vm.showTitle },
                      on: {
                        paginationclick: function($event) {
                          return _vm.goToPage($event, "pagination")
                        }
                      }
                    })
                  ]
                },
                proxy: true
              }
            ],
            null,
            true
          )
        },
        "carousel",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _vm._l(_vm.$slots, function(slot, name) {
        return _c(
          "template",
          { slot: name },
          [
            name === "default" ? _vm._t("default") : _vm._e(),
            _vm._v(" "),
            name !== "default" ? _vm._t(name) : _vm._e()
          ],
          2
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }